// extracted by mini-css-extract-plugin
export default {"row":"editEvent_row__zMx74","col":"editEvent_col__kkLjY","card":"editEvent_card__ervyU"};